export default __webpack_public_path__ + "6158977794e9cb56cdf71a6e260a2562.png";